import React from 'react';
import './Dealer.css';

import { FaMapLocationDot } from 'react-icons/fa6';
import { FaPhoneAlt } from 'react-icons/fa';

import { Link } from 'react-router-dom';



const Dealer = ({ dealer }) => {

  // Extracting data from dealer object
  const { image, title, location, phone } = dealer; 

  return (
    <div className="dealer-item">

      {/* Display the number of listings for the dealer */}
      <div className="label">{dealer.details.listings}</div>

      {/* Dealer image */}
      <div className="image">
        <img src={image} alt={title} />
      </div>

      {/* Dealer title with navigation link */}
      <Link to={{ pathname: `/Dealers/${title}` }} state={dealer}>
        <h3>{title}</h3>
      </Link>

      {/* Dealer contact details */}
      <div className="details">

        {/* Display location with an icon */}
        <h5>
          <FaMapLocationDot className='icon' />
          <span>{location}</span>
        </h5>

        {/* Display phone number with an icon */}
        <h5>
          <FaPhoneAlt className='icon' />
          <span>{phone}</span>
        </h5>

      </div>

    </div>
  );
};

export default Dealer;